exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__custom-input___DVr5c.styles__custom-input___DVr5c.styles__custom-input___DVr5c{width:100%;height:38px;box-sizing:border-box;background-color:#fff;border:1px solid #e1e6eb;border-radius:4px;font-size:14px;line-height:18px;color:#333}.styles__custom-input___DVr5c.styles__custom-input___DVr5c.styles__custom-input___DVr5c:disabled{color:#000;border:1px solid #e1e6eb;background-color:#f6f6f6}", ""]);

// Exports
exports.locals = {
	"custom-input": "styles__custom-input___DVr5c"
};